import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from 'features/core/shared/mvs-page/page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';
import {PageHeaderConfig} from 'features/core/shared/service/page/page-header-config.interface';
import {
    MvsConfigHeaderComponent
} from 'features/core/shared/components/mvs-config-header/mvs-config-header.component';

/**
* Eingangsfreigabe page (P3) for Sachbearbeitung.
*
* Review/approval screen for commission-import DRAFTS: the user picks a Gesellschaft
* (cn.CommissionPartner), sees all import DRAFTS for it, can select-all and then approve or
* reject them in bulk.
*
* Header runs in Component-Mode via MvsConfigHeaderComponent ('Eingangsfreigabe'), with
* cross-links to the Provisions-Import, the Provisions-Dashboard, the Abgleich screen and the
* cn config page so all cn screens stay mutually reachable.
*
* NOTE (architecture shell): the Gesellschaft selection, the DRAFT list with select-all and the
* bulk approve/reject orchestration live in the hosted CnImportReviewComponent
* (mvs-cn-import-review) and its data layer, which the Data / Component specialist wires next.
* This file establishes the routed page skeleton, the inheritance contract and the header only;
* the body currently hosts a placeholder until that component is declared in CnModule (CnModule
* has no CUSTOM_ELEMENTS_SCHEMA, so the not-yet-existing selector must not be referenced in the
* template).
*/
@Component({
    selector: 'mvs-cn-import-review-page',
    templateUrl: './cn-import-review.page.html',
    styleUrls: ['./cn-import-review.page.scss'],
    standalone: false
})
export class CnImportReviewPage extends PageComponent implements OnInit {

    defaultLabel: string = 'Eingangsfreigabe';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        this.defaultLabel = 'Eingangsfreigabe';
        super.ngOnInit();
        this.initialized = true;
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Eingangsfreigabe',
                categoryTypeMode: 'configuration',
                icon: 'fa-light fa-clipboard-check',
                links: [
                    {label: 'Import', icon: 'fa-light fa-file-import', url: 'cn/import'},
                    {label: 'Dashboard', icon: 'fa-light fa-gauge', url: 'cn/dashboard'},
                    {label: 'Abgleich', icon: 'fa-light fa-scale-balanced', url: 'cn/reconciliation'},
                    {label: 'Konfiguration', icon: 'fa-light fa-coins', url: 'cn/config'}
                ]
            }
        };
    }
}
